var _LogoutIcon;
import * as React from 'react';
import { Container, Section, Username, Description, LogoutIcon, Name } from './Menu.styles';
import { MenuLink } from './MenuLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const defaultElement = 'div';
function Menu(props, ref) {
  const {
    description,
    logoutLink,
    logoutLinkLabel,
    username,
    links,
    onLinkClick
  } = props;
  return /*#__PURE__*/_jsxs(Container, {
    className: "ovpn-profile-menu",
    ref: ref,
    children: [/*#__PURE__*/_jsxs(Section, {
      children: [username && /*#__PURE__*/_jsx(Username, {
        as: "p",
        title: username,
        className: "ovpn-profile-menu-username",
        children: username
      }), typeof description === 'string' ? /*#__PURE__*/_jsx(Description, {
        as: "p",
        className: "ovpn-profile-menu-description",
        children: description
      }) : description]
    }), (links == null ? void 0 : links.length) > 0 && /*#__PURE__*/_jsx(Section, {
      onClick: onLinkClick != null ? onLinkClick : undefined,
      children: links.map(link => /*#__PURE__*/_jsxs(MenuLink, {
        link: link,
        className: "ovpn-profile-menu-link",
        children: [/*#__PURE__*/_jsx(Name, {
          children: link.name
        }), link.icon]
      }, link.name))
    }), /*#__PURE__*/_jsx(Section, {
      children: /*#__PURE__*/_jsxs(MenuLink, {
        link: logoutLink,
        className: "ovpn-profile-menu-link",
        children: [/*#__PURE__*/_jsx(Name, {
          children: logoutLinkLabel != null ? logoutLinkLabel : 'Logout'
        }), _LogoutIcon || (_LogoutIcon = /*#__PURE__*/_jsx(LogoutIcon, {}))]
      })
    })]
  });
}
export default /*#__PURE__*/React.forwardRef(Menu);